import { z } from 'zod/v3';

import { frequentlyOrderProductSchema } from './frequently-order';

/**
 * 마켓 상품 (MarketSelectProductResponseV2)
 * frequently-order 의 상품 모델과 동일 DTO 이므로 재사용한다.
 */
export const marketProductItemSchema = frequentlyOrderProductSchema;
export type MarketProductItem = z.infer<typeof marketProductItemSchema>;

/** 커서 페이지네이션된 마켓 상품 목록 (CursorPagedResponseMarketSelectProductResponseV2) */
export const cursorPagedMarketProductsSchema = z.object({
  /** 상품 목록 */
  content: z.array(marketProductItemSchema),
  /** 다음 페이지 여부 */
  hasNextPage: z.boolean(),
  /** 마지막 항목 ID */
  lastId: z.number().optional(),
  /** 다음 페이지 요청용 커서 */
  searchAfter: z.array(z.string()).optional(),
  /** 정렬 타입 */
  sortType: z.string().optional(),
});
export type CursorPagedMarketProducts = z.infer<
  typeof cursorPagedMarketProductsSchema
>;
